module.exports = __webpack_public_path__ + "static/media/logo.16640271.png";